import { CSSProperties } from 'react'
import { PhoneStoryState } from '../../hooks/usePhoneStory'

/** For elements that start hidden and animate in once their story plays. */
export function revealAnimation(state: PhoneStoryState, animationName: string, delayMs: number, durationMs: number, iterationCount: number | 'infinite' = 1): CSSProperties {
  if (state === 'unplayed') return { opacity: 0 }
  if (state === 'playing') return { animation: `${animationName} ${durationMs}ms cubic-bezier(.2,.8,.2,1) ${delayMs}ms ${iterationCount} both` }
  return {}
}
